import { AfterContentInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { UserProfileForCreation } from 'projects/shared/src/lib/models/UserProfileForCreation';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { UserProfileService } from 'projects/shared/src/lib/services/user-profile.service';

@Component({
  selector: 'user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class UserProfileComponent implements OnInit {

  avatar: string = './assets/img/avatar-emty.png';

  userProfileForm!: FormGroup;

  userProfile!:UserProfileForCreation;

  isById = false;
  id!:string;
  isLoadingResults = true;
  isRateLimitReached = false;
  sq_spinner: any = './assets/img/sq-spinner.gif';

  constructor( private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private tenantService: TenantService,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private userProfileService: UserProfileService) { }
 

  ngOnInit(): void {
        // this.userProfileService.getUser().subscribe({
        //   next:(userProfile: UserProfileForCreation) => {       
        //     this.isLoadingResults = false;
        //     this.userProfile = userProfile;
        //     this.buildUserProfileFile(this.userProfile);
        //   }
        // });
    this.route.data.subscribe((data: any) => {
      this.id = data['resolvedData'];
      console.log("=========> user-profile: id = ", this.id)
      if (!this.id || this.id === "") {
        this.userProfileService.getUser().subscribe({
          next:(userProfile: UserProfileForCreation) => {       
            this.isLoadingResults = false;
            this.userProfile = userProfile;
            this.buildUserProfileFile(this.userProfile);
          }
        });
      } else {
        this.isById = true;
        this.userProfileService.getUserById(this.id).subscribe({
          next:(userProfile: UserProfileForCreation) => {       
            this.isLoadingResults = false;
            this.userProfile = userProfile;
            this.buildUserProfileFile(this.userProfile);
          }
        });
      }
    },
      // error
    );
  }


  buildUserProfileFile(userProfile: UserProfileForCreation) {
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    this.userProfileForm = this.formBuilder.group({
      // userName: [userProfile.username, Validators.required],
      email: [userProfile.email, [Validators.required, Validators.pattern(emailregex)]],
      isEmailConfirmed: [userProfile.isEmailConfirmed],
      givenName: [userProfile.givenName],
      familyName: [userProfile.familyName],
      phoneNumber: [userProfile.phoneNumber],
      statusMessage: [userProfile.statusMessage],
      // fullName: [userProfile.fullName],
      // webSite: [userProfile.website],
      // profile: [userProfile.profile],
      // streetAddress: [userProfile.streetAddress],
      // locality: [userProfile.locality],
      // region: [userProfile.region],
      // postalCode: [userProfile.postalCode],
      // country: [userProfile.country]
    });
  }

  // createUserProfileForm() {
  //   let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  //   this.userProfileForm = this.formBuilder.group({
  //     userName: ['', Validators.required],
  //     email: [null, [Validators.required, Validators.pattern(emailregex)]],
  //     isEmailConfirmed: [false],
  //     phoneNumber: [null],
  //     statusMessage: [null],
  //     fullName: [null],
  //     webSite: [null],
  //     profile: [null],
  //     streetAddress: [null],
  //     locality: [null],
  //     region: [null],
  //     postalCode: [null],
  //     country: [null]
  //   });
  // }

  cancel() {
    if (this.isById){
      (this.tenantService.currentTenantName != this.tenantService.SystemManagerAbbreviation)?
      this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-users']) :
      this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-users'])
    }
    else {
      (this.tenantService.currentTenantName != this.tenantService.SystemManagerAbbreviation)?
      this.router.navigate(['/', this.tenantService.currentTenantName, 'all-projects']) :
      this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-tenants'])
    }
}

  updateUser() {
    if(this.userProfileForm.valid) {

      this.userProfile.phoneNumber = this.userProfileForm.value.phoneNumber;
      this.userProfile.fullName = this.userProfileForm.value.fullName;
      this.userProfile.givenName = this.userProfileForm.value.givenName;
      this.userProfile.familyName = this.userProfileForm.value.familyName;
      this.userProfile.website = this.userProfileForm.value.webSite;
      this.userProfile.profile = this.userProfileForm.value.profile;
      this.userProfile.streetAddress = this.userProfileForm.value.streetAddress;
      this.userProfile.locality = this.userProfileForm.value.locality;
      this.userProfile.region = this.userProfileForm.value.region;
      this.userProfile.postalCode = this.userProfileForm.value.postalCode;
      this.userProfile.country = this.userProfileForm.value.country;

      if (this.isById) {
        this.userProfileService.updateProfileById(this.id, this.userProfile).subscribe({
          next:(data) => {
            this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERPROFILEUPADTED"]}`);
            (this.tenantService.currentTenantName != this.tenantService.SystemManagerAbbreviation)?
            this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-users']) :
            this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-users'])
  
          },
          error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERPROFILEUPADTEDERROR"]}`)
        });    
      } else {
        this.userProfileService.addProfile(this.userProfile).subscribe({
          next:(data) => {
            this.userProfileService.currentUserName = this.userProfileForm.value.givenName + " " + this.userProfileForm.value.familyName;
            this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERPROFILEUPADTED"]}`);
            (this.tenantService.currentTenantName != this.tenantService.SystemManagerAbbreviation)?
            this.router.navigate(['/', this.tenantService.currentTenantName, 'all-projects']) :
            this.router.navigate(['/', this.tenantService.currentTenantName, 'manage-tenants'])
  
          },
          error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERPROFILEUPADTEDERROR"]}`)
        });    
      }
    }

  }

  SendVerificationEmail(email:string) {
    console.log("Send Verification Email to ",email)
    this.userProfileService.sendEmail(email).subscribe({
      next: (data) => {
        this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["EMAILVERIFICATIONSENT"]}`);
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["EMAILVERIFICATIONSENTERROR"]}`)
    });
  }

}
